export enum DevicesSortBy {
  SERIAL_NUMBER = 'serialNumber',
  PATIENT = 'patient',
}
